import { createErrorNotice, setLoading } from "./stripeHelpers"

export default function () {
  const setupForm = document.getElementById("js-setup-intent-form")
  const paymentEle = document.getElementById("payment-element")
  if (setupForm && paymentEle) {
    let clientSecret = setupForm.dataset.stripeClientSecret
    const stripe = Stripe(setupForm.dataset.stripePublicKey)
    let elements

    const appearance = {
      theme: "stripe",
      variables: {
        colorPrimary: setupForm.dataset.colorPrimary,
        colorBackground: "#ffffff",
        colorText: "#1c1c1c",
        colorDanger: "#c53030",
        colorIconTabSelected: "#1c1c1c",
        fontFamily: "Graphik Web, Helvetica Neue, Helvetica, Arial, sans-serif",
        spacingUnit: "6px",
        borderRadius: "10px",
        fontSize3Xs: "16px",
      },
      rules: {
        ".Input": {
          border: "solid 1px #858585",
        },
        ".Tab:focus": {
          outline: "solid 3px #1c1c1c",
          border: "none",
          boxShadow: "none",
        },
        ".Input:focus": {
          outline: "solid 3px #1c1c1c",
          border: "none",
          boxShadow: "none",
        },
        ".Tab--selected": {
          color: "#1c1c1c",
          border: "solid 1px var(--colorPrimary)",
          backgroundColor: setupForm.dataset.colorSelected,
        },
      },
    }
    elements = stripe.elements({ appearance, clientSecret })

    const paymentElementOptions = {
      paymentMethodOrder: ["us_bank_account", "card"],
      layout: "tabs",
      fields: { billingDetails: { name: "never", email: "never" } },
    }

    const paymentElement = elements.create("payment", paymentElementOptions)
    paymentElement.mount("#payment-element")

    paymentElement.on("change", function (event) {
      if (event.complete && event.value.type === "us_bank_account") {
        const formEle = document.getElementById("js-setup-intent-form")
        const submitBtn = formEle.querySelector("button[type=submit]")
        submitBtn.click()
      }
    })

    setupForm.addEventListener("submit", async function (event) {
      event.preventDefault()
      setLoading(true)

      let userFullName = document.getElementById("user-full-name-input").value

      const { error } = await stripe.confirmSetup({
        elements,
        confirmParams: {
          return_url: setupForm.dataset.returnUrl,
          payment_method_data: {
            billing_details: {
              email: setupForm.dataset.userEmail,
              name: userFullName,
            },
          },
        },
      })

      if (error.type === "card_error" || error.type === "validation_error") {
        createErrorNotice(error.message)
      } else {
        createErrorNotice("An unexpected error occurred.")
      }

      setLoading(false)
    })
  }
}
